"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfnSplitIntoBatchesInputDto = void 0;
class SfnSplitIntoBatchesInputDto {
}
exports.SfnSplitIntoBatchesInputDto = SfnSplitIntoBatchesInputDto;
//# sourceMappingURL=SfnSplitIntoBatchesInputDto.js.map